import { RootState } from 'rootReducer';

export const selectPaymentInformationResponse = (state: RootState) =>
  state.ui.apps.survey.Handlebars.paymentInformationResponse;

export const selectCopiedReferralLink = (state: RootState) =>
  state.ui.apps.survey.Handlebars.copiedReferralLink;
